import styled from 'styled-components';

export const WrapperStyled = styled.div`
  margin-top: 2rem;
`;
